/**
 * Resolve the canonical formative-assessment number.
 *
 * assessment_number is the source of truth. Titles are only a compatibility
 * fallback for older timelines that did not have the column populated.
 */
export const getAssessmentNumber = (assessment, fallback = 1) => {
  const explicit = Number(assessment?.assessment_number);
  const title = String(assessment?.title || assessment?.name || '');
  const labelled = title.match(/\b(?:CAM|CAT|CA)\s*(?:#|[-:]|\s)*([0-9]+)\b/i);
  const labelledNumber = labelled ? Number(labelled[1]) : null;

  if (Number.isInteger(explicit) && explicit > 0) {
    // Some legacy timelines were created with the column default (1) while
    // their title already identified CAM2/CAM3/CAM4. Treat that exact
    // default/title conflict as legacy data; otherwise the stored column is
    // authoritative.
    if (explicit === 1 && labelledNumber && labelledNumber > 1) return labelledNumber;
    return explicit;
  }

  if (labelledNumber) return labelledNumber;

  const assessmentLabel = title.match(/\b(?:formative\s+)?assessment\s*(?:#|no\.?|number)?\s*([0-9]+)\b/i);
  if (assessmentLabel) return Number(assessmentLabel[1]);

  const idLabel = String(assessment?.id || '').match(/\b(?:CAM|CAT)[-_ ]?([0-9]+)\b/i);
  if (idLabel) return Number(idLabel[1]);

  // Callers can pass 0 as an explicit "no number" sentinel when building a
  // scoped timeline map. Normal UI fallbacks remain CAM1 or the supplied
  // positive sequence number.
  if (Number(fallback) === 0) return 0;
  return Number.isInteger(Number(fallback)) && Number(fallback) > 0 ? Number(fallback) : 1;
};
